import Card from "./card";
import CheckBadge from "./check-badge";
import PrimaryButton from "./primary-button";
import Timeline from "./timeline";
import { UTILITY_STEPS, formatMoney } from "./utilities-config";

export default function HomeDone({ cashBack, onContinue }) {
  return (
    <Card steps={UTILITY_STEPS} activeStep={1} progress={100} footer={<PrimaryButton onClick={onContinue}>Go to my account</PrimaryButton>}>
      <div className="su-status">
        <CheckBadge />
        <h2 className="su-title">Stake Internet is on the way.</h2>
        <p className="su-subtitle">MyUtilities has your request. Your {formatMoney(cashBack)} lands once setup is confirmed.</p>
        <Timeline
          items={[
            { when: "Today", title: "Call requested", body: "A MyUtilities concierge picks it up.", done: true },
            { when: "A few days", title: "They call you", body: "They compare providers and set up everything you picked." },
            { when: "Setup day", title: "Connected", body: `Your ${formatMoney(cashBack)} lands once everything is live.` },
          ]}
        />
      </div>
    </Card>
  );
}
